import { reactive, ref } from 'vue';

// @ts-expect-error
const isApplePayLoaded = ref(!!window.ApplePaySession);
const isGooglePayLoaded = ref(false);
const isFormLoaded = ref(false);

export function usePaymentForm() {
  function setApplePayLoaded() {
    isApplePayLoaded.value = true;
  }

  function setGooglePayLoaded() {
    isGooglePayLoaded.value = true;
  }

  function setFormLoaded() {
    isFormLoaded.value = true;
  }

  return reactive({
    isApplePayLoaded,
    isGooglePayLoaded,
    isFormLoaded,
    setApplePayLoaded,
    setGooglePayLoaded,
    setFormLoaded,
  });
}
